module.exports = __webpack_public_path__ + "static/logistics-drive-store-e716c945ca5e42aa6918a5d9160ba3f6.png";